import React from "react";
import { RoleManageContextProvider } from "./ViewRoleView";
import RoleManageView from "./views/RoleView";

const ViewRoleManagePage = () => {
  return (
    <div>
      <RoleManageContextProvider>
        <RoleManageView />
      </RoleManageContextProvider>
    </div>
  );
};

export default ViewRoleManagePage;
